import "./RenewalAll.scss";
import { useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button } from "../../../../../components/ui/Buttons/Button/Button";
import { IconSvg } from "../../../../../utils/constants/icons/iconSvg.constant";
import { useDispatchedActions, useTranslation } from "../../../../../hooks";
import { scrollToElementById } from "../../../../../utils/helpers/scrollToElementById";
import { ApiService } from "../../../../../services/ApiService";
import { errorToast } from "../../../../../utils/helpers/customToast.helper";
import { clearObjectEmptyValues } from "../../../../../utils/helpers/clearObjectEmptyValues";

export const RenewalAll = ({ renewalProxyCount }) => {
  const { lang } = useParams();
  const { setSelectedRows } = useDispatchedActions();
  const { activeData } = useSelector((state) => state.content);
  const { cabinet: { orders: { renewAll, renewMessage } } } = useTranslation();
  const [searchParams] = useSearchParams();

  const dateStart = searchParams.get("dateStart") || null;
  const dateEnd = searchParams.get("dateEnd") || null;

  const renewAllHandler = async () => {
    const filterParams = {
      country: searchParams.get("country"),
      runningOut: true,
      description: searchParams.get("description")
    };

    const filterByDateParams = {
      filterOffDate: !!dateStart || !!dateEnd,
      filterOffDateStart: dateStart,
      filterOffDateEnd: dateEnd
    };

    clearObjectEmptyValues(filterParams);

    try {
      const { data, status } = await ApiService
        .getAllUserOrdersByFolder(activeData?.proxy?.code, null, filterParams, filterByDateParams);

      if (status !== 200) throw Error();

      setSelectedRows(data);
      scrollToElementById("renewal");
    } catch (e) {
      errorToast("Something went wrong", lang);
    }
  };

  return (
    <>
      {!!renewalProxyCount && (
        <div className="renewal-all">
          <div className="renewal-all__container">
            <div className="renewal-all__icon">
              <IconSvg tag="files"/>
            </div>
            <div className="renewal-all__title-wrapper">
              <div
                className="renewal-all__title">{`${renewAll} ${renewalProxyCount ? `(${renewalProxyCount} IPs)` : ""}`}</div>
              <div className="renewal-all__description">{renewMessage}</div>
            </div>
          </div>
          <Button tab="confirm" onClick={renewAllHandler}>
            <div>{renewAll}</div>
            <IconSvg tag="restart"/>
          </Button>
        </div>
      )}
    </>
  );
};
